import styled from 'styled-components'
import { useNavigate } from 'react-router-dom'
import { ChatSearchResult } from '../../Common/Types/Search'
import { Highlight } from '@search-components'
import { formatAbbreviatedDate } from '../../Common/Utils/dateUtils'

const ResultCard = styled.div`
  padding: 1rem;
  border: 1px solid ${(props) => props.theme.colors.border};
  border-radius: ${(props) => props.theme.box.borderRadius};
  background-color: ${(props) => props.theme.colors.primary};
  cursor: pointer;
  transition: border-color 0.15s, box-shadow 0.15s;

  &:hover {
    border-color: ${(props) => props.theme.colors.accentColor};
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  }
`

const MetaRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.375rem;
`

const SourceBadge = styled.span`
  font-size: 0.75rem;
  color: ${(props) => props.theme.colors.font.grey2};
  background-color: ${(props) => props.theme.colors.secondary};
  border-radius: 4px;
  padding: 0.1rem 0.4rem;
`

const DateText = styled.span`
  font-size: 0.75rem;
  color: ${(props) => props.theme.colors.font.grey2};
`

const SnippetText = styled.p`
  font-size: 0.8125rem;
  color: ${(props) => props.theme.colors.font.tertiary};
  margin: 0;
  line-height: 1.5;
`

interface ChatResultProps {
  result: ChatSearchResult
}

export const ChatResult = ({ result }: ChatResultProps) => {
  const navigate = useNavigate()

  return (
    <ResultCard onClick={() => navigate(`/chat/${result.chatId}`)}>
      <MetaRow>
        <SourceBadge>{result.source}</SourceBadge>
        {result.lastMessageDate && (
          <DateText>{formatAbbreviatedDate(result.lastMessageDate)}</DateText>
        )}
      </MetaRow>
      <SnippetText>
        <Highlight html={result.snippet} />
      </SnippetText>
    </ResultCard>
  )
}
